import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { ChooseJourney } from "@/components/ChooseJourney";
import { PathwayBadge } from "@/components/PathwayBadge";
import { RelatedLinks } from "@/components/RelatedLinks";
import { usePageMeta } from "@/hooks/usePageMeta";
import { SITE } from "@/data/site";

export default function JourneyPage() {
  usePageMeta(
    "Choose Your Journey",
    "Find your USDD Academy pathway — kids classes, adult training, workshops, online courses, events, schools and the BA pathway in development."
  );
  return (
    <>
      <Header />
      <main>
        <PageHero
          overline="Choose Your Journey"
          title="Where do you"
          highlight="start?"
          description="USDD Academy offers seven distinct pathways. Pick the lane that fits your goals — we'll guide you to the right programme and the next step to take."
          ctaPrimary={{ label: "Start Your Journey", to: "/contact" }}
          ctaSecondary={{ label: "Talk to us", to: "/contact" }}
          bg={SITE.hero}
        />
        <ChooseJourney />
        <PathwayBadge testId="journey-pathway-badge" />
        <RelatedLinks
          title="Popular pathways"
          items={[
            { tag: "Kids", label: "USDD Kids", desc: "Ages 6–17 · confidence + culture", to: "/kids" },
            { tag: "Adults", label: "Weekly Training", desc: "Hip-Hop, Afro, Dancehall and more", to: "/training" },
            { tag: "B2B", label: "Schools & Organisations", desc: "Bespoke bookings on request", to: "/schools-organisations" },
          ]}
        />
      </main>
      <Footer />
    </>
  );
}
